(function ($) {
  var gnavSearchV1 = {
    $searchTpl: $('.gnav-search-v1'),
    $searchForm: $('form', this.$searchTpl),
    $textBox: $('input.form-text', this.$searchForm),
    $submitButton: $('input.form-submit', this.$searchForm),
    $tabletContainer: $('.form-tablet', this.$searchForm)
  };

  Drupal.behaviors.gnavSearchV1 = {
    get: function (key) {
      return gnavSearchV1[key];
    },

    set: function (key, val) {
      gnavSearchV1[key] = val;
    },

    attach: function () {
      var self = this,
        searchForm = self.get('$searchForm'),
        textBox = searchForm.find('input#search'),
        tabletTextBox = searchForm.find('input#tablet-search');

      // var tabletInput = self.get('$tabletContainer').find('.tablet-input .wrap');
      // self.get('$searchTpl').find('.form-text').clone().appendTo(tabletInput);

      self.get('$tabletContainer').find('img').on('click', function() {
        if (self.get('$tabletContainer').hasClass('open') === false) {
          $(this).parents('.form-tablet').addClass('open');
          $(this).siblings('.tablet-input').animate({
            width: '260px'
          }, 1000, function () {
          });
          self.get('$tabletContainer').find('.form-text').focus();
        }
      });

      self.get('$tabletContainer').find('.form-text').focusout(function () {
        $(this).parents('.tablet-input').animate({
          width: '0'
        }, 500, function () {
          self.get('$tabletContainer').removeClass('open');
        });
      });

      /*
    // Not needed. This is being done directly on the search <input> text field on gnav_search_v1.html
    // The following 2 focus/blur event handlers can be consolidated
    self.get('$textBox').each(function() {
      var searchBoxDefaultText = $(this).attr('default-placeholder');

      $(this).focus(function() {
        // Set the default form field value
        if ($(this).val() == searchBoxDefaultText) {
          $(this).val('').addClass('active');
        }
      }).blur(function() {
        // Replace the form field default value
        if ($(this).val().length < 1) {
          $(this).val(searchBoxDefaultText).removeClass('active');
        }
      });
    });

    self.get('$tabletContainer').find('.form-text').each(function() {
      var searchBoxDefaultText = $(this).attr('default-placeholder');

      $(this).focus(function() {
        // Set the default form field value
        if ($(this).val() == searchBoxDefaultText) {
          $(this).val('').addClass('active');
        }
      }).blur(function() {
        // Replace the form field default value
        if ($(this).val().length < 1) {
          $(this).val(searchBoxDefaultText).removeClass('active');
        }
      });
    });
//*/
      /* // This is on hold, per Alex's request
    // Find input search term in predictive search product/term results and higlight it (bold)
    var typeaHead = searchTpl.find('#typeahead-wrapper');
    typeaHead.bind('hover', function(event) {
      var result = $(this).find('.product-results .result');
      result.each(function() {
        var str = searchFormText.val();
        str = str.toLowerCase().replace(/\b[a-z]/g, function(letter) {
          return letter.toUpperCase();
        });
        if( $(this).find('a:contains(' + str + ')').length > 0 ) {
          var resA = $(this).find('a.link');
          resA.html(resA.text().replace(str, '<span class="term">' + str + '</span>'));
        }
      });
    });
//*/
      // Assign default search box text value from hidden div
      var placeHolder = self.get('$searchTpl').find('.place-holder').text();

      if (textBox.val() === '') {
        textBox.val(placeHolder);
      }

      // Match tablet input value to default search input
      tabletTextBox.keyup(function () {
        textBox.val($(this).val());
      });

      // Submit form when Submit button on Mobile Safari keyboard is pressed
      tabletTextBox.on('keypress', function (e) {
        if (e.which === 13) {
          self.get('$searchTpl').find('#perlgem-search-form').trigger('submit');
        }
      });

      // Build new default esearch URL for redirect
      var esearchpath = 'esearch',
        esearchKey = '?search=',
        esearchVal,
        esearchUrl;

      // Redirect to custom esearch URL on form submit. This fixes wrongly formed URL search query strings
      self.get('$searchTpl').find('#perlgem-search-form').on('submit', function (event) {
        $(this).attr('data-submitted', 'true');
        event.preventDefault();
        if (window.location.search.length >= 1) {
        // esearchHref = esearchHref.replace(esearchpath + window.location.search, '');
        }
        // 1 char search terms like 'k' are returning a blank search results page
        // Assign 'kk' to esearchVal to prevent blank search results pages
        if (textBox.val() === 'k') {
          esearchVal = 'kk';
        } else if (textBox.val() === textBox.attr('data-value')) {
          esearchVal = '';
        } else {
          esearchVal = textBox.val();
        }
        esearchUrl = '/' + esearchpath + esearchKey + esearchVal;
        window.location = esearchUrl;
      });
    }

  };
})(jQuery);
